function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useContext } from 'react';
import { connect, useSelector } from 'react-redux';
import { modalActions } from '../../../reducers/modal.reducer';
import { cmsActions } from '../../../reducers/cms.reducer';
import PopupData from './Popup.context';
import PopupFilesAttach from './PopupFilesAttach.modal';
import UploadFile from '../../common/assets/UploadFile.modal';
import PopupFilesEdit from './PopupFilesEdit.modal';
import Card from '../../common/card/Card.react';
import CardHeader from '../../common/card/CardHeader.react';
import CardBody from '../../common/card/CardBody.react';
import Table from '../../common/table/Table.react';
import Button from '../../common/Button.react';
import Confirm from '../../common/modal/Confirm.modal';
var PopupFiles = function PopupFiles(_ref) {
  var showModalAction = _ref.showModalAction,
    popupsAction = _ref.popupsAction;
  var _useContext = useContext(PopupData),
    _useContext2 = _slicedToArray(_useContext, 1),
    state = _useContext2[0];
  var popupID = state.popupID,
    files = state.files,
    type = state.type;
  var bucket = useSelector(function (s) {
    return s.config.bucket;
  });
  if (type !== 'files') return null;
  var tableData = {
    columns: {
      _id: {
        title: 'ID',
        visible: false
      },
      title: 'Title',
      type: {
        title: 'Type',
        size: 'contain'
      },
      slot: {
        title: 'Slot',
        visible: false
      }
    },
    data: files === null || files === void 0 ? void 0 : files.map(function (x) {
      var _x$assetID, _x$assetID2;
      return {
        _id: x === null || x === void 0 ? void 0 : (_x$assetID = x.assetID) === null || _x$assetID === void 0 ? void 0 : _x$assetID._id,
        title: x === null || x === void 0 ? void 0 : x.title,
        type: x === null || x === void 0 ? void 0 : (_x$assetID2 = x.assetID) === null || _x$assetID2 === void 0 ? void 0 : _x$assetID2.extension,
        fileID: x === null || x === void 0 ? void 0 : x._id,
        slot: x === null || x === void 0 ? void 0 : x.slot,
        filename: x === null || x === void 0 ? void 0 : x.assetID.filename
      };
    }),
    actions: {
      file: {
        onClick: function onClick(row) {
          window.open("".concat(bucket, "/").concat(row.filename), '_blank');
        }
      },
      delete: {
        onDelete: function onDelete(row) {
          showModalAction({
            component: /*#__PURE__*/React.createElement(Confirm, {
              onConfirm: function onConfirm() {
                popupsAction({
                  formData: {
                    popupID: popupID,
                    assetID: row._id
                  },
                  method: 'delete',
                  route: 'files'
                });
              }
            })
          });
        }
      }
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "page__content--block"
  }, /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(CardHeader, {
    title: "Files"
  }), /*#__PURE__*/React.createElement(Table, _extends({}, tableData, {
    sort: {
      by: 'slot'
    },
    tr: {
      onClick: function onClick(row) {
        showModalAction({
          component: /*#__PURE__*/React.createElement(PopupFilesEdit, {
            popupID: popupID,
            files: files,
            fileID: row.fileID
          })
        });
      }
    }
  })), /*#__PURE__*/React.createElement(CardBody, null, /*#__PURE__*/React.createElement(Button, {
    label: "Add",
    permission: "edit-pos-popup",
    onClick: function onClick() {
      showModalAction({
        component: /*#__PURE__*/React.createElement(UploadFile, {
          onUploaded: function onUploaded(file) {
            showModalAction({
              component: /*#__PURE__*/React.createElement(PopupFilesAttach, {
                file: file,
                popupID: popupID
              })
            });
          }
        })
      });
    },
    style: {
      width: 120
    }
  }))));
};
var mdtp = {
  showModalAction: modalActions.show,
  popupsAction: cmsActions.popups
};
export default connect(null, mdtp)(PopupFiles);